export default function UseCases() {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-blue-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            こんな時にご利用ください
          </h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto"></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          <div className="bg-white p-6 rounded-xl border border-blue-100 hover:border-blue-300 transition-all hover:shadow-lg">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 flex items-center justify-center bg-pink-100 rounded-lg flex-shrink-0">
                <i className="ri-presentation-line text-xl text-pink-500"></i>
              </div>
              <p className="text-gray-700 leading-relaxed pt-2">
                学会スライド・医師面談資料をすぐに作りたい
              </p>
            </div>
          </div>
          
          <div className="bg-white p-6 rounded-xl border border-blue-100 hover:border-blue-300 transition-all hover:shadow-lg">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 flex items-center justify-center bg-purple-100 rounded-lg flex-shrink-0">
                <i className="ri-lock-unlock-line text-xl text-purple-500"></i>
              </div>
              <p className="text-gray-700 leading-relaxed pt-2">
                OAで読めない論文を安全に入手したい
              </p>
            </div>
          </div>
          
          <div className="bg-white p-6 rounded-xl border border-blue-100 hover:border-blue-300 transition-all hover:shadow-lg">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-lg flex-shrink-0">
                <i className="ri-building-line text-xl text-green-500"></i>
              </div>
              <p className="text-gray-700 leading-relaxed pt-2">
                製薬企業の業務で急ぎで文献が必要
              </p>
            </div>
          </div>
          
          <div className="bg-white p-6 rounded-xl border border-blue-100 hover:border-blue-300 transition-all hover:shadow-lg">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 flex items-center justify-center bg-yellow-100 rounded-lg flex-shrink-0">
                <i className="ri-book-open-line text-xl text-yellow-600"></i>
              </div>
              <p className="text-gray-700 leading-relaxed pt-2">
                大学図書館では入手できない論文が必要
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}